import React, {useEffect} from 'react';
import { useSearchParams } from 'react-router-dom';
import CustomersTable from '../../components/customers/Table';
import { InfoCard, InfoCardProps } from '../../components/core/InfoCard';
import { ActiveIcon, NariaIcon, NumberIcon, ProfileIcon } from '../../assets/icons';
import { getCustomerStats } from '../../backend-services';
import {useCustomerStore} from "../../state";
import shallow from "zustand/shallow";
import {useCustomerSearch} from "../../hooks";
import { formatMoney } from '../../utils';
import DropdownButton from '../../components/common/Table/MobileTableComponent/DropdownOptions';

interface CustomerStatsData {
  totalInvoiceValue: number;
  totalDeletedCustomers: number;
  totalNewCustomers: number;
  totalOverDueInvoices: number;
  totalBilled:number;
  totalTransactions:number;
  totalCustomers:number;

}

const ViewCustomersPages = () => {
  const [stats, setStats] = React.useState<CustomerStatsData>({
    totalInvoiceValue: 0,
    totalDeletedCustomers: 0,
    totalNewCustomers: 0,
    totalOverDueInvoices: 0,
    totalBilled:0,
    totalTransactions:0,
    totalCustomers:0,

  });

  const [params] = useSearchParams();
  const fetchCustomerStats = async () => {
    const response = await getCustomerStats();
    setStats(response);
  };
  const { fetchCustomers, fetchMoreData, onSearchData, fetchData } = useCustomerStore(
    (state) => ({
      fetchCustomers: state.fetchCustomers,
      fetchMoreData: state.fetchMoreData,
      onSearchData: state.setSearchText,
      fetchData: state.fetchData,
    }),
    shallow,
  );

  const { data: searchResult, isSearching, handleSearch: handleCustomerSearch } = useCustomerSearch();


  const { customers, isLoading, range, pagination, searchText } = useCustomerStore(
    (state) => ({
      customers: state.customers,
      isLoading: state.isLoading,
      searchText: state.searchText,
      range: state.range,
      pagination: state.pagination,
      error: state.error,
    }),
    shallow,
  );

  useEffect(() => {
    fetchCustomers();
  }, []);

  React.useEffect(() => {
  }, [customers]);
  

  React.useEffect(() => {
    fetchCustomerStats();
  }, []);


  React.useEffect(() => {
  }, [stats]);

  const infoCardData = [
    {
      title: 'Total Billed',
      value: `${stats.totalBilled}`,
      color: 'secondary',
      icon: <NariaIcon />,
      isLoading: isLoading,
    },
    {
      title: 'Total Mumber of Transaction',
      value: `${stats.totalTransactions}`,
      color: 'active',
      icon: <NumberIcon />,
      isLoading: isLoading,
    },
    {
      title: 'Total Customers',
      value: `${stats.totalCustomers}`,
      color: 'primary',
      icon: <ProfileIcon />,
      isLoading: isLoading,
    },
    {
      title: 'Active Customers',
      value: `${stats.totalNewCustomers}`,
      color: 'danger',
      icon: <ActiveIcon />,
      isLoading: isLoading,
    },
  ] as InfoCardProps[];
  return (
    <>
    <div className='flex flex-col allign-center '>
     <div className='flex justify-between items-center'>
      <h1 className="font-bold text-[18px] 540:ml-[3em] 412:ml-[-1em] 414:ml-[-1em] sm:ml-[5em] ml-[-1.6em] bigmd:ml-[1.9em] xl:text-[20px] lg:ml-[0.3em] md:ml-[2.2em] xl:ml-[0.1em] 360:ml-[-2.1em] ">Customers</h1>
      <p className='text-[12px] 2xl:text-[14px] 540:mr-[3em]  md:mr-[2.2em] bigmd:mr-[2.2em] 375:mr-[-3.2em] 414:mr-[-2.2em] 360:mr-[-3.3em] 412:mr-[-1.2em] mr-[-2.7em]'>Last 30 days</p>
    </div>
      
  
    <div className='hidden lg:block mt-4'>
  <div className="grid grid-cols-4 gap-2 xl:ml-[0.3em] lg:ml-[0.3em] ">
    {infoCardData.map((cardData, index) => (
      <div className='' key={index}>
        <InfoCard {...cardData} />
      </div>
    ))}
    {infoCardData.length < 4 &&
      Array.from({ length: 4 - infoCardData.length }).map((_, index) => (
        <div key={index}></div>
      ))}
  </div>
</div>
<div className=" lg:hidden mt-4 ">
  <div className="flex justify-center md:ml-[0.5em] bigmd:w-[] gap-5 sm:gap-8 sm:ml-[-0.3em] ml-[1.5em] 375:ml-[0.2em] 414:ml-[0.3em] 360:ml-[0.2em] 412:ml-[-0.1em] smmd:">
  {infoCardData.slice(0, 2).map((cardData, index) => (
    <div key={index}>
      <InfoCard {...cardData} />
    </div>
  ))}
</div>
<div className="mt-6 md:mt-2"></div>
<div className="flex justify-center md:ml-[0.5em] gap-5 sm:gap-8 sm:ml-[-0.3em] ml-[-2em] 375:ml-[0.2em]  414:ml-[0.3em] 360:ml-[0.2em] 412:ml-[-0.1em]">
  {infoCardData.slice(2, 4).map((cardData, index) => (
    <div key={index}>
      <InfoCard {...cardData} />
    </div>
  ))}
</div>

</div>
    <div className='hidden md:block justify-center items-center md:px-[40px] px-0 lg:px-0 biglg:px-0 xl:px-0'>
      <CustomersTable
        customers={customers}
        isLoading={isLoading}
        isSearching={isSearching}
        fetchMoreData={fetchMoreData}
        onSearchData={onSearchData}
        handleSearch={handleCustomerSearch}
        meta={pagination}
        searchResult={searchResult}
      />
    </div>

    <div className='flex md:hidden justify-center items-center'>
      <CustomersTable
        customers={customers}
        isLoading={isLoading}
        isSearching={isSearching}
        fetchMoreData={fetchMoreData}
        onSearchData={onSearchData}
        handleSearch={handleCustomerSearch}
        meta={pagination}
        searchResult={searchResult}
      />
      
    </div>
    </div> 
    </>
  );
};

export { ViewCustomersPages };
